import { render, staticRenderFns } from "./ReminderAnnounceMailPopup.vue?vue&type=template&id=9a0be63c"
import script from "./ReminderAnnounceMailPopup.vue?vue&type=script&lang=js"
export * from "./ReminderAnnounceMailPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports